import { Store } from "@ngrx/store";

import { TrackingActions } from "../../state-management/tracking/tracking.action";
import { AppState } from "../../interfaces/app-state.interface";
import { TrackEventType } from "../../enum/event-types";

type DispatchTracksEventParams = {
    store: Store<AppState>,
    eventType: TrackEventType,
    origin: string,
    element?: string,
    subElement?: string,
    scenario?: string,
    category?: string,
}

/**
 * Dispara evento para o Mixpanel
 *
 * `store`: Store que possua um reducer para TrackingActions.trackEvents
 *
 * `eventType`: O nome do evento que será utilizado no mixpanel
 *
 * `origin`: Descreve um grupo de eventos que aquele evento pertence. Eg: Login para eventos da tela de Login
 *
 * `element`: A descrição do elemento que dispara esse evento. Eg: Botão Entrar
 *
 * `subElement`: A descrição de elementos secundarios. Eg: Um link dentro de um accordion ficaria algo como `element: 'Accordion Esqueci Minha Senha', subElement: 'Link Criar Nova Conta'`
 *
 * `scenario`: Cenario em que aquela ação ocorre. Eg: Um modal que abre apos sua senha ser bloqueada teria `scenario: 'Senha Bloqueada'`
 *
 * `category`: Um "sub grupo" de elementos além da origin. Eg: Dentro da origin 'Login' temos um agrupamento de FAQ, nesse caso temos os seus elementos com `origin: 'Login', category: 'FAQ'`
 */
export const dispatchTrackEvent = ({ store, eventType, origin, element, subElement, scenario, category }: DispatchTracksEventParams) => {
    store.dispatch({
        type: TrackingActions.trackEvents,
        payload: {
            type: eventType,
            events: {
                origin,
                element,
                subElement,
                scenario,
                category,
            },
        },
    });
}
